import { memo, useContext } from "react";

// MUI
import { Box, Chip, Tooltip } from "@mui/material";

// Icons
import WorkHistoryIcon from '@mui/icons-material/WorkHistory'
import { Context } from "./Context";
import { gettingShiftStatus } from "../../../utils/Timecard";
import { useTranslation } from "react-i18next";
import moment from "moment";

const ShiftCell = memo(({params}) => {
    const { t } = useTranslation('timecard.table');

    const regex = /auto-generated-row-null/;
    
    const {
        cacheRange1,
        apiRef,
        periods,
        range1,
    } = useContext(Context);

    const gettingOpacity = () => {
        const period = periods.find(period => period.full_name === params?.rowNode?.groupingKey)

        if(period){
            if(moment(period.end_date, 'YYYY-MM-DD').isSameOrAfter(moment(range1[1], 'YYYY-MM-DD'))){
                return 0.5
            }else{
                return 1
            }
        }else{
            return 1
        }
    }

    return (
        <>
            { regex.test(params?.id) ?
                <Box 
                    sx={{
                        width: '100%',
                        display:'grid', 
                        placeItems: 'center',
                        alignItems: 'center',
                        alignContent: 'center',
                        gap: '10px',
                        p: 1.5
                    }}
                >
                    { 
                        <Box 
                            sx={{
                                width: '100%', 
                                textAlign: 'center',
                                overflowX: 'hidden', 
                                textOverflow: 'ellipsis', 
                                whiteSpace: 'nowrap',
                                opacity: gettingOpacity(),
                            }}
                        >
                            { gettingShiftStatus(t, params, apiRef, cacheRange1) }
                        </Box>
                    }
                </Box>
                :
                <Box 
                    sx={{
                        width: '100%',
                        display:'grid', 
                        placeItems: 'center',
                        alignItems: 'center',
                        alignContent: 'center',
                        gap: '10px',
                        p: 1.5
                    }}
                >
                    { params?.value?.map((shift, index) => 
                        <Tooltip
                            key={`${index}-${shift.date}`}
                            title={params?.row?.open_period.open === false ? 'periodod cerrado' : undefined}
                        >
                            <Chip
                                disabled={params?.row?.open_period.open === false}
                                key={`${index}-${shift.date}`}
                                icon={<WorkHistoryIcon sx={{p: 0.25}}/>} 
                                label={`${shift.start} - ${shift.end}`}
                            />
                        </Tooltip>
                    )}
                </Box>
            }
        </>
    )
})

export { 
    ShiftCell 
}